import Spinner from '../Spinner';

// Tek buton tanımı. Önceden her sayfa kendi sınıf dizisini yazıyordu; aynı yeşil
// buton kimi yerde px-3.5 py-1.5, kimi yerde px-4 py-2 idi.
const TURLER = {
  primary:   'bg-brand-600 text-white hover:bg-brand-700 shadow-sm',
  secondary: 'bg-white text-slate-700 border border-slate-200 hover:bg-slate-50',
  ghost:     'text-slate-600 hover:bg-slate-100',
  success:   'bg-emerald-600 text-white hover:bg-emerald-700 shadow-sm',
  danger:    'bg-rose-600 text-white hover:bg-rose-700 shadow-sm',
  warning:   'bg-amber-500 text-white hover:bg-amber-600 shadow-sm',
};
const BOYUTLAR = {
  sm: 'text-xs px-2.5 py-1.5 gap-1.5 rounded-lg',
  md: 'text-sm px-3.5 py-2 gap-2 rounded-lg',
  lg: 'text-sm px-4 py-2.5 gap-2 rounded-xl',
};

export default function Button({
  children, tur = 'secondary', boyut = 'md', icon: Icon,
  yukleniyor = false, disabled, className = '', ...rest
}) {
  return (
    <button
      disabled={disabled || yukleniyor}
      className={`inline-flex items-center justify-center font-medium transition-colors
                  disabled:opacity-55 disabled:cursor-not-allowed
                  ${TURLER[tur] || TURLER.secondary} ${BOYUTLAR[boyut]} ${className}`}
      {...rest}
    >
      {yukleniyor ? <Spinner size="sm" /> : (Icon && <Icon size={boyut === 'sm' ? 14 : 16} />)}
      {children}
    </button>
  );
}
